/**
 * Cookie name for the indication whether the banner was closed.
 */
export const PRO_BANNER_WAS_CLOSED_COOKIE = 'pro_banner_was_closed';

export const cookies = {
    PRO_BANNER_WAS_CLOSED_COOKIE,
};
